(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-slider"] && !Shopify.designMode) return;
  try {
    
Fancybox.bind("[data-fancybox]", {

});
$(".owl-carousel").each(function () {
  const itemCount = $(this).find("a").length;

  $(this).owlCarousel({
    center: true,
    items: 1,
    autoHeight: true,
    loop: false
  });
});


  } catch(e) { console.error(e); }
})();
})();
